import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { type ReactNode } from 'react'

interface ErrorMessageProps {
  children: ReactNode
}

const styles = stylex.create({
  errorMessage: {
    color: colors.red600,
    marginTop: '4px',
  },
})

export const ErrorMessage = ({ children }: ErrorMessageProps) => {
  return (
    <Text variant="caption" rootStyle={styles.errorMessage}>{children}</Text>
  )
}
